import React, { useEffect, useState } from "react";

const LatestProducts = () => {
    const backendUrl = process.env.REACT_APP_BACKEND_URI;

    const [latestProducts, setLatestProducts] = useState([]);
    const [activeProduct, setActiveProduct] = useState(null);

    /* ================= FETCH ================= */
    useEffect(() => {
        fetch(`${backendUrl}/products`)
            .then(res => res.json())
            .then(data => {
                const latest = data.filter(
                    p => p.is_latest_product === true
                );
                setLatestProducts(latest);
                if (latest.length > 0) {
                    setActiveProduct(latest[0]);
                }
            })
            .catch(console.error);
    }, [backendUrl]);

    /* ================= UI ================= */
    return (
        <div
            style={{
                padding: "120px 50px 50px",
                maxWidth: "1350px",
                margin: "auto",
            }}
        >
            <h2 style={{ marginBottom: "20px" }}>Latest Products</h2>

            {/* TOP LIST */}
            <div style={{ marginBottom: "30px" }}>
                <ul style={{ listStyle: "none", padding: 0 }}>
                    {latestProducts.map(product => (
                        <li
                            key={product._id}
                            onClick={() => setActiveProduct(product)}
                            style={{
                                cursor: "pointer",
                                padding: "6px 0",
                                color:
                                    activeProduct?._id === product._id
                                        ? "#0a67c9"
                                        : "#333",
                                fontWeight:
                                    activeProduct?._id === product._id
                                        ? "600"
                                        : "400",
                            }}
                        >
                            + {product.title}
                        </li>
                    ))}
                </ul>
            </div>

            {/* DETAILS */}
            {activeProduct && (
                <div>
                    <h3
                        style={{
                            color: "#a00000",
                            marginBottom: "10px",
                            width: "fit-content",
                        }}
                    >
                        {activeProduct.title}
                    </h3>

                    {/* IMAGES */}
                    <div
                        style={{
                            display: "flex",
                            gap: "15px",
                            flexWrap: "wrap",
                            marginBottom: "20px",
                        }}
                    >
                        {activeProduct.images?.map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt=""
                                style={{
                                    width: "160px",
                                    height: "160px",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                }}
                            />
                        ))}
                    </div>

                    {/* CONTENT SECTIONS */}
                    {activeProduct.content_sections?.length > 0 && (
                        <>
                            <h4
                                style={{
                                    margin: "30px 0 20px",
                                    fontSize: "24px",
                                }}
                            >
                                PRODUCT DETAILS
                            </h4>

                            {activeProduct.content_sections.map(
                                (section, si) => {
                                    const heading =
                                        section.title?.trim() ||
                                        section.sub_title?.trim();

                                    return (
                                        <div
                                            key={si}
                                            style={{ marginBottom: "22px" }}
                                        >
                                            {/* TITLE / SUB TITLE */}
                                            {heading && (
                                                <h5
                                                    style={{
                                                        fontSize: "18px",
                                                        marginBottom: "6px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    {heading}
                                                </h5>
                                            )}

                                            {/* SUB TITLE (only if title exists) */}
                                            {section.title?.trim() &&
                                                section.sub_title?.trim() && (
                                                    <p
                                                        style={{
                                                            marginBottom: "8px",
                                                            color: "#555",
                                                            fontWeight: "500",
                                                        }}
                                                    >
                                                        {section.sub_title}
                                                    </p>
                                                )}

                                            {/* CONTENT */}
                                            <ul>
                                                {section.contents.map(
                                                    (c, ci) => (
                                                        <li
                                                            key={ci}
                                                            style={{
                                                                listStyle:
                                                                    "disc",
                                                                margin:
                                                                    "0 16px",
                                                                lineHeight:
                                                                    "25px",
                                                            }}
                                                        >
                                                            {c}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    );
                                }
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default LatestProducts;
